import axios from "axios";
import router from '@/router'

const state = {
  imageFileTypes: ['jpg', 'jpeg', 'png', 'gif'],
  issue_status: [],
  issue_priority: [],
  issue_label: [],
  project_status: [],
  projects: [],
  issues: [],
  status_new_project: "",
  validateSendInvitesForm: {status: null, error:null},
  addFileForm: {status: null, error:null, data: null},

  status_tag: [
		'<label><i class="fa fa-times-circle"></i> Cancelled</label>',
		'<label><i class="fa fa-check-circle purple"></i> Done</label>',
		'<label><i class="fa fa-adjust yellow"></i> In Progress</label>',
		'<label><i class="fa fa-circle-notch"></i> Todo</label>',
		'<label><i class="fa fa-bullseye"></i> Backlog</label>'
	],
  status_tag_icon: [
		'<i class="fa fa-times-circle light-text2"></i>',
		'<i class="fa fa-check-circle purple"></i>',
		'<i class="fa fa-adjust yellow"></i>',
		'<i class="fa fa-circle-notch light-text2"></i>',
		'<i class="fa fa-bullseye light-text2"></i>'
	],
  priority_tag_icon: [
		'<svg fill="#6B6F76" width="13" height="13" viewBox="0 0 13 13"><rect x="1" y="8" width="3" height="6" rx="1"></rect><rect x="6" y="5" width="3" height="9" rx="1" fill-opacity="0.1"></rect><rect x="11" y="2" width="3" height="12" rx="1" fill-opacity="0.1"></rect></svg>',
		'<svg fill="#6B6F76" width="13" height="13" viewBox="0 0 13 13"><rect x="1" y="8" width="3" height="6" rx="1"></rect><rect x="6" y="5" width="3" height="9" rx="1"></rect><rect x="11" y="2" width="3" height="12" rx="1" fill-opacity="0.1"></rect></svg>',
		'<svg fill="#6B6F76" width="13" height="13" viewBox="0 0 13 13"><rect x="1" y="8" width="3" height="6" rx="1"></rect><rect x="6" y="5" width="3" height="9" rx="1"></rect><rect x="11" y="2" width="3" height="12" rx="1"></rect></svg>',
		'<i class="fa fa-exclamation-circle light-text3"></i>',
		'<i class="fa fa-ellipsis-h xsmall light-text3"></i>'
	]
};

const getters = {
  ws_issue_status: state => state.issue_status,
  ws_issue_priority: state => state.issue_priority,
  ws_issue_label: state => state.issue_label,
  ws_project_status: state => state.project_status,
  ws_projects: state => state.projects,
  ws_issues: state => state.issues,
  ws_status_new_project: state => state.status_new_project,
  ws_status_tag: state => state.status_tag,
  ws_status_tag_icon: state => state.status_tag_icon,
  ws_priority_tag_icon: state => state.priority_tag_icon,
};

const actions = {
  async newIssue ({ commit }, data) {
    const response = await axios({
      method: 'POST',
      url: "/issue/api/issue/new/",
      data: data,
    }).then(response => {
      const payload = {"data": response.data}
      commit('set_new_issue', payload)
    }).catch(error => {

    })
  },

  async editIssue ({ commit }, payload) {

    const response = await axios({
      method: 'PUT',
      url: `issue/api/issue/item/${payload.issue_id}/`,
      data: payload.data,
    }).then(response => {
      commit('edited_issue', response.data)
      router.push({name: 'issuedetail', params: {slug: router.currentRoute.params.slug, issueslug: response.data.slug} })
    }).catch(error => {
        // if (error.response.data.error == "not found") {
        //   commit('get_issues_404')
        // }
    })
  },

  async newProject ({ commit }, data) {
    const response = await axios({
      method: 'POST',
      url: "/issue/api/project/new/",
      data: data,
    }).then(response => {
      // console.log(router.history.current.params.slug);
      const payload = {"data": response.data, "status": "set"}
      commit('set_new_project', payload)
      // router.push({name: 'projects', params: {slug: router.currentRoute.params.slug} })
    }).catch(error => {

    })
  },

  async getProjects ({ commit }, workspace_id) {
    const response = await axios({
      method: 'GET',
      url: `issue/api/project/get_all/${workspace_id}/`,
      // data: userInfo,
    }).then(response => {
      commit('get_projects', response.data)
    }).catch(error => {
        if (error.response.data.error == "not found") {
          commit('get_projects_404')
        }
    })
  },

  async getIssues ({ commit }, workspace_id) {
    const response = await axios({
      method: 'GET',
      url: `issue/api/issue/get_all/${workspace_id}/`,
      // data: userInfo,
    }).then(response => {
      commit('get_issues', response.data)
    }).catch(error => {
        if (error.response.data.error == "not found") {
          commit('get_issues_404')
        }
    })
  },


  async projectStatus ({ commit }) {
    const response = await axios({
      method: 'GET',
      url: "issue/api/project/status/",
    }).then(response => {
      commit('get_project_status', response.data)
    }).catch(error => {
      alert('Please reload page')
    })
  },

  async issueStatus ({ commit }) {
    const response = await axios({
      method: 'GET',
      url: "issue/api/issue/status/",
    }).then(response => {
        commit('get_issue_status', response.data)
    }).catch(error => {
        alert('Please reload page')
    })
  },

  async issuePriority ({ commit }) {
    const response = await axios({
      method: 'GET',
      url: "issue/api/issue/priority/",
    }).then(response => {
        commit('get_issue_priority', response.data)
    }).catch(error => {

    })
  },

  async issueLabel ({ commit }) {
    const response = await axios({
      method: 'GET',
      url: "issue/api/issue/label/",
    }).then(response => {
        commit('get_issue_label', response.data)
    }).catch(error => {

    })
  },

  async sendMainInvites ({ commit }, data) {
    const response = await axios({
      method: 'POST',
      url: "account/api/workspaceinvite/",
      data: data,
    }).then(response => {
      const payload = {"data": response.data}
      commit('send_invites', {"status": 1, "data": response.data})
    }).catch(error => {
      if (error.response.data) {
        commit('send_invites', {"status": 2, "data": error.response.data})
      }
    })
  },

  async addIssueFiles ({ commit }, data) {
    const response = await axios({
      method: 'POST',
      url: "issue/api/issue/file/",
      data: data,
    }).then(response => {
      const payload = {"data": response.data}
      commit('add_files', {"status": 1, "data": response.data})
    }).catch(error => {
      if (error.response.data) {
        commit('add_files', {"status": 2, "data": error.response.data})
      }
    })
  },

  logout({commit}){
    return new Promise((resolve, reject) => {
      commit('logout')
    })
  },

};

const mutations = {
  get_issue_status(state, data){
    state.issue_status = data
  },
  get_issue_priority(state, data){
    state.issue_priority = data
  },
  get_issue_label(state, data){
    state.issue_label = data
  },
  get_project_status(state, data){
    state.project_status = data
  },
  get_projects(state, data){
    state.projects = data
  },

  get_issues(state, data){
    state.issues = data
  },

  edited_issue (state, data){
    const index = state.issues.findIndex((val) => val.id === data.id);
    if (index !== -1) {
      state.issues.splice(index, 1, data);
    }
  },

  set_new_project(state, data){
    state.projects.unshift(data['data'])
    state.status_new_project = data['status']
  },
  set_new_issue(state, data){
    state.issues.unshift(data['data'])
    // state.status_new_project = data['status']
  },
  get_projects_404(state){
    state.projects = []
  },
  get_issues_404(state){
    state.issues = []
  },

  send_invites(state, data){
    // success
    if (data.status == 1) {
      state.validateSendInvitesForm.status = 1
    }
    // error- token validation
    if (data.status == 2) {
      state.validateSendInvitesForm.status = 2
      state.validateSendInvitesForm.error = data.data
    }
    // reset
    if (data.status == 4) {
      Object.keys(state.validateSendInvitesForm).forEach(key => state.validateSendInvitesForm[key]=null);
    }
  },

  add_files(state, data){
    // success
    if (data.status == 1) {
      // console.log(data);
      state.addFileForm.data = data.data
      state.addFileForm.status = 1
    }
    // error- token validation
    if (data.status == 2) {
      // alert("A problem occured with your file.");
      state.addFileForm.status = 2
      state.addFileForm.error = data.data
    }
    // reset
    if (data.status == 3) {
      Object.keys(state.addFileForm).forEach(key => state.addFileForm[key]=null);
    }
  },




  logout(state){
    state.issue_status = []
    state.issue_priority = []
    state.issue_label = []
    state.project_status = []
    state.projects = []
    state.issues = []
    state.status_new_project = ""
    state.validateSendInvitesForm = {status: null, error:null}
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
